/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_File_Name_No_Leading_TrailingInputs */



/**
* | output |
* | --- |
* | "File name cannot have leading or trailing spaces" |
*
* @param {Spaces_File_Name_No_Leading_TrailingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_name_no_leading_trailing = /** @type {((inputs?: Spaces_File_Name_No_Leading_TrailingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Name_No_Leading_TrailingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Dateiname darf keine führenden oder nachgestellten Leerzeichen enthalten")
	return /** @type {LocalizedString} */ ("File name cannot have leading or trailing spaces")
});